import React, { memo } from "react";

const Radio = ({ name, handleChange, value, defaultChecked, label }) => {
  return (
    <div className="flex items-center">
      <input
        id={value}
        name={name}
        type="radio"
        defaultChecked={defaultChecked}
        className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500 shrink"
        onChange={() => {
          handleChange(value);
        }}
      />

      <label
        htmlFor={value}
        className="ml-3 block text-base text-gray-700 grow cursor-pointer"
      >
        {label}
      </label>
    </div>
  );
};

// eslint-disable-next-line react/display-name
const RadioList = memo(
  ({ input: { onChange, value, name }, options = [], groupBy }) => {
    let lastHeading = null;
    let currentHeading = null;
    let GroupHeading = null;

    return (
      <ul className="px-2 text-base">
        {options.map(({ value: radioValue, label, ...rest }) => {
          if (groupBy) currentHeading = rest[groupBy];
          if (groupBy && lastHeading !== currentHeading) {
            GroupHeading = (
              <h2 className="font-semibold text-base mt-2 mb-.5">
                {currentHeading}
              </h2>
            );
            lastHeading = currentHeading;
          } else {
            GroupHeading = null;
          }

          return (
            <li
              className="border-b border-gray-200 last:border-b-0 py-1"
              key={radioValue}
            >
              {GroupHeading}
              <Radio
                handleChange={onChange}
                value={radioValue}
                defaultChecked={radioValue === value}
                label={label}
                name={name}
              />
            </li>
          );
        })}
      </ul>
    );
  }
);

export default RadioList;
